/**
 * Self-Service Calculator
 *
 * Contact: dap@visana.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type Level = 'LEVEL_ONE' | 'LEVEL_TWO' | 'LEVEL_THREE';

export const Level = {
    One: 'LEVEL_ONE' as Level,
    Two: 'LEVEL_TWO' as Level,
    Three: 'LEVEL_THREE' as Level
};

